import React from 'react';
import { useSelector } from 'react-redux';
import { isDesktop } from '../../../common/helpers/utility/screenHelper';
import Icon from '../../../common/styles/Icon';
import searchResource from '../../../locales/th/search.json';
import { getDeviceType } from '../../../store/common/selector';
import { WholeState as SearchState } from '../../../store/search/type';
import {
  FilterButtonIcon,
  FlexContainer,
  Header,
  MobileFiltersButton,
  ProjectCountText,
  Wrapper,
} from './SearchFilterHeader.style';
import SrpBlurb from './SrpBlurb';

interface Props {
  projectCount: number;
  title: string;
  srpBlurb?: string;
  onClickFilterButton: () => void;
}

const SearchFilterHeader: React.FunctionComponent<Props> = ({
  projectCount,
  title,
  srpBlurb,
  onClickFilterButton,
}) => {
  const projectsText = searchResource.searchFilter.projects;
  const isLoading = useSelector<SearchState>((state) =>
    state.search ? state.search.loadingProjectsCarousel : false,
  );
  const hasProject = useSelector<SearchState>((state) =>
    state.search ? state.search.projectsItems.length > 0 : false,
  );
  const deviceType = useSelector(getDeviceType);

  const showProjectCountTextPlaceHolder = isLoading && !hasProject;

  return (
    <Wrapper>
      {title && <Header data-test="srp-filter-title">{title}</Header>}
      <SrpBlurb text={srpBlurb} />
      <FlexContainer>
        <ProjectCountText data-test="srp-filter-desc">{`${
          showProjectCountTextPlaceHolder ? ' - ' : projectCount
        } ${projectsText}`}</ProjectCountText>
        {!isDesktop(deviceType) && (
          <MobileFiltersButton onClick={onClickFilterButton}>
            {searchResource.searchFilter.filters}
            <FilterButtonIcon>
              <Icon iconName={'filters'} leftOfText size={20} />
            </FilterButtonIcon>
          </MobileFiltersButton>
        )}
      </FlexContainer>
    </Wrapper>
  );
};

export default SearchFilterHeader;
